import { ResponseError, type ResponseErrorInit } from "./responseError"

export const NO_ACCESS_TYPE = "https://dovetail.puzzel.com/problems/no-access"

export class NoAccessResponseError extends ResponseError {
  public override readonly type = NO_ACCESS_TYPE
  public missing: string[]

  public constructor({
    missing,
    ...init
  }: ResponseErrorInit & { missing: string[] }) {
    super(init)
    this.name = "NoAccessResponseError"
    this.missing = missing
  }
}
